
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import AudioUpload from '@/views/account-management/components/AudioUpload.vue';
import moment from 'moment';


@Component({
  components: {
    AudioUpload,
  },
})
export default class RecordingChainDrawer extends Vue {
  visible = false;

  title = '录音列表';

  @lazyInject(BrandService)
  brandService!: BrandService;

  @Ref('audioUpload')
  audioUpload!: AudioUpload;

  labelCol = {
    span: 8,
  };

  wrapperCol = {
    span: 16,
  };

  labelAlign = 'right';

  labelWidth = '220px';

  autoComplete = 'off';

  createTime: any = [];


  columns = [
    {
      title: 'POIID',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 180,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 180,
    },
    {
      title: '联系时间',
      dataIndex: 'start_time',
      key: 'start_time',
      align: 'center',
      width: 180,
    },
    {
      title: '地推员名称',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: 180,
    },
    {
      title: '录音时长',
      dataIndex: 'call_time',
      key: 'call_time',
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (text) {
          return `${text}秒`;
        }
        return text;
      },
    },
    {
      title: '推送状态',
      dataIndex: 'pushed',
      key: 'pushed',
      align: 'center',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 240,
    },
  ];


  statusList = [
    {
      label: '全部',
      value: '',
    },
    {
      label: '已推送',
      value: '1',
    },
    {
      label: '推送中',
      value: '2',
    },
    {
      label: '推送失败',
      value: '-1',
    },
  ];

  dataSource: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
  };

  kaId = 0;

  form: any = {
    kaId: 0,
    page: 1,
    pageSize: 10,
    shop_name: '',
    poi: '',
    contact_time_start: '',
    contact_time_end: '',
    pushed: '',
  };

  onChangePage(page: any) {
    this.pagination.current = page;
    this.form.page = page;
    this.getAudioList(this.form);
  }

  open(row: any) {
    this.title = `录音列表 - ${row.name}`;
    this.form.kaId = row.id;
    this.kaId = row.id;
    this.getAudioList(this.form);
    this.visible = true;
  }

  showDrawer() {
    this.visible = true;
  }

  uploadAudio() {
    this.audioUpload.open();
  }

  onSubmit() {
    this.getAudioList(this.form);
  }


  onChange(val: any) {
    if (!val.length) {
      this.form.contact_time_start = null;
      this.form.contact_time_end = null;
      return;
    }
    this.createTime = val;
    this.$set(
      this.form,
      'contact_time_start',
      moment(val[0]).format('YYYY-MM-DD'),
    );
    this.$set(
      this.form,
      'contact_time_end',
      moment(val[1]).format('YYYY-MM-DD'),
    );
  }

  onReset() {
    this.form = {
      kaId: this.kaId,
      page: 1,
      pageSize: 10,
      shop_name: '',
      poi: '',
      contact_time_start: '',
      contact_time_end: '',
      pushed: '',
    };

    this.createTime = [];

    this.getAudioList(this.form);
  }

  async getAudioList(data: any) {
    const { page, pageSize, pushed, kaId, shop_name, poi, contact_time_start, contact_time_end } = data;
    const params: any = {
      page: page || 1,
      ka_id: kaId,
      pageSize: pageSize || 10,
    };
    if (pushed) {
      params.pushed = pushed;
    }
    if (shop_name) {
      params.shop_name = shop_name;
    }
    if (poi) {
      params.poi = poi;
    }
    if (contact_time_start) {
      params.contact_time_start = contact_time_start;
    }
    if (contact_time_end) {
      params.contact_time_end = contact_time_end;
    }
    if (pushed) {
      params.pushed = pushed;
    }
    const res = await this.brandService.brandAudioUpload(params) as any;
    this.dataSource = res.list;
    this.pagination.total = res.total;
  }
  async downloadAudio(url: any, fileName: any) {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(blobUrl);
  }

  async pushAudio(row: any) {
    try {
       const res = await this.brandService.brandAudioPushVoice({
        voice_id: row.id,
      }) as any;
      if (res) {
        this.$message.success('操作成功');
        this.getAudioList(this.form);
      }
    } catch (error) {
      this.$message.error('操作失败');
    }
  }

  onClose() {
    this.visible = false;
  }
}
